/** Ключ localStorage: явный opt-out уведомлений о новых заказах */
export const ADMIN_NEW_ORDER_NOTIFICATIONS_ENABLED_KEY =
  'admin-new-order-notifications-enabled'

/**
 * Включены ли уведомления о новых заказах на этом устройстве.
 * Permission ОС «granted» сам по себе недостаточно — пользователь мог выключить в админке.
 */
export const areAdminNewOrderNotificationsEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  if (typeof Notification === 'undefined') {
    return false
  }

  if (Notification.permission !== 'granted') {
    return false
  }

  // По умолчанию при granted считаем включёнными, пока пользователь явно не выключил
  return (
    window.localStorage.getItem(ADMIN_NEW_ORDER_NOTIFICATIONS_ENABLED_KEY) !==
    '0'
  )
}

/**
 * Сохраняет флаг включения/выключения уведомлений в localStorage.
 * @param isEnabled — true = включены, false = выключены пользователем
 */
export const setAdminNewOrderNotificationsEnabled = (
  isEnabled: boolean
): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(
      ADMIN_NEW_ORDER_NOTIFICATIONS_ENABLED_KEY,
      isEnabled ? '1' : '0'
    )
  } catch (error) {
    console.error(
      '[notifications] Не удалось записать флаг в localStorage:',
      error
    )
  }
}
